import { Box, Heading, Paragraph } from '@zillow/constellation-10';

import {
  wizardFlexContainerStyles,
  wizardFormSectionContainerStyles,
  wizardHeadingStyles,
} from '../../../../styles/wizard';

import GenderPreferenceFormField from '../../../PostingPath/GenderPreferenceFormField';
import PageWizard from '../../../Wizard/PageWizard';
import WizardTipCardContainer from '../../../WizardTipCardContainer';

import type { WizardBodyTemplateProps } from '../../../WizardStepController';

const RenterPreferences = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  ...rest
}: WizardBodyTemplateProps) => {
  return (
    <PageWizard
      {...rest}
      title=""
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onGoToNextStep || undefined}
      onBackClick={onGoToPrevStep || undefined}
      onExitTriggered={onExitWizard}
    >
      <Box css={wizardFlexContainerStyles}>
        <Box css={wizardFormSectionContainerStyles.raw()}>
          <Heading level={2} textStyle="heading-sm" css={wizardHeadingStyles}>
            Do you have any gender preferences?
          </Heading>

          <GenderPreferenceFormField />
        </Box>

        <WizardTipCardContainer header="Gender preference">
          <Paragraph>
            The Fair Housing Act allows you to state gender preferences when you’ll be sharing living areas with other
            tenants.
          </Paragraph>
        </WizardTipCardContainer>
      </Box>
    </PageWizard>
  );
};

export default RenterPreferences;
